import { render, staticRenderFns } from "./SplitSlotDatesModal.vue?vue&type=template&id=572511c6&"
import script from "./SplitSlotDatesModal.vue?vue&type=script&lang=js&"
export * from "./SplitSlotDatesModal.vue?vue&type=script&lang=js&"
import style0 from "./SplitSlotDatesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports